import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

ScrollTrigger.config({
    autoRefreshEvents: "visibilitychange,DOMContentLoaded,load",
    ignoreMobileResize: true
});

gsap.from(".section-hero .container", {
    opacity: 0,
    y: 130,
    duration: 1.2,
    ease: "power2.out",
    delay: 0.5,
});

function initParallaxEffect() {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 768px)", () => {
        const parallaxTween = gsap.to(".reveal-section", {
            yPercent: -100,
            ease: "none",
            scrollTrigger: {
                trigger: ".last-scrolling-section",
                start: "bottom top",
                end: "+=100%",
                pinSpacing: false,
                scrub: true,
                pin: true,
                pinType: "fixed",
            }
        });

        return () => {
            parallaxTween.scrollTrigger?.kill();
            parallaxTween.kill();
        };
    });

    return mm;
}

function getYoutubeId(url) {
    if (!url) return null;

    const matches = url.match(/(?:youtube\.com\/watch\?v=|youtube\.com\/embed\/|youtu\.be\/)([0-9A-Za-z_-]{11})/);
    return matches ? matches[1] : null;
}

function initYoutubeVideos() {
    $(".hero-youtube-js").each(function () {
        const element = this;
        const url = element.getAttribute("data-youtube-url");
        const orientation = element.getAttribute("data-orientation") || "landscape";

        if (!url) return;

        const videoId = getYoutubeId(url);
        if (!videoId) return;

        const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=0&rel=0&loop=1&playlist=${videoId}&playsinline=1`;

        element.innerHTML = `<iframe class="hero-youtube-iframe is-${orientation}" src="${embedUrl}" title="Background video" frameborder="0" allow="autoplay; fullscreen" allowfullscreen loading="lazy"></iframe>`;
    });
}

let lastWidth = window.innerWidth;
let resizeTimeout = null;

$(window).on("resize", function () {
    const currentWidth = window.innerWidth;

    if (currentWidth === lastWidth) return;

    lastWidth = currentWidth;

    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
        ScrollTrigger.refresh();
    }, 250);
});

$(window).on("load", function () {
    initYoutubeVideos();
    initParallaxEffect();
});